<template>
    <QrDialog :url="url" :trigger="trigger">
        <template v-slot:activator="scope">
            <slot name="activator" v-bind="scope">
                <div></div>
            </slot>
        </template>
    </QrDialog>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import QrDialog from "@/components/SingleUse/QrDialog.vue";

export default {
    name: 'MachineQrDialog',
    props: {
        machineId: [Number, String],
        trigger: Number,
    },
    components: {
        QrDialog,
    },
    mixins: [clientAPI],

    data() {
        return {
            url: 'SuperSecretPage.net',
            loading: false,
        };
    },

    mounted() {
        this.getUrl();
    },

    methods: {
        async getUrl() {
            this.loading = true;
            clientAPI.methods.getQrUrlByMachineId(this.machineId).then((result) => {
                //console.log(result.qr);
                this.url = result.qr
            }).finally(() => {
                this.loading = false;
            });
        },
    },

    computed: {},

    watch: {},
};
</script>


<style lang='scss' scoped></style>